<template>
  <div
    class="d-flex flex-column justify-center align-center pa-0"
    style="position: relative; height: 60vh;"
  >
    <div
      class="image-div"
      :style="{ 'background-image': 'url(' + image + ')' }"
    ></div>
    <div class="text-div justify-center align-center d-flex flex-column">
      <h2 class="white--text text-center">
        {{ title }}
        <br />
        <small>
          {{ subtitle }}
        </small>
      </h2>
      <v-btn large color="primary_dark" class="white--text mt-4" :to="route"
        >Requisitos</v-btn
      >
    </div>
  </div>
</template>
<script>
export default {
  props: ["title", "subtitle", "text", "type", "image", "route"],
  data() {
    return {};
  },
};
</script>
<style scoped>
.image-div {
  background-position: center;
  background-size: cover;
  height: 100%;
  left: 0px;
  bottom: 0px;
  position: absolute;
  right: 0px;
  top: 0px;
  width: 100%;
  z-index: 1;
}
.text-div {
  left: 0px;
  bottom: 0px;
  position: absolute;
  right: 0px;
  top: 0px;
  z-index: 2;
}
</style>
